import { createIcon } from '../icon'
import SweatshirtIcon from '../svg/SweatshirtIcon'

export const SweatshirtIconDefault = createIcon(SweatshirtIcon)
